<template>
  <v-dialog v-model="dialog" width="300">
    <template v-slot:activator="{ on, attrs }">
      <v-row justify="center">
        <v-btn class="mt-5" :disabled="!active" v-bind="attrs" v-on="on">
          回答する
        </v-btn>
      </v-row>
    </template>

    <v-card>
      <v-card-title class="text-h5 justify-center">
        確認
      </v-card-title>
      <v-divider class="mb-5" />
      <v-card-text class="text-center">
        回答を送信しますか？
      </v-card-text>
      <v-card-text class="text-center">
        送信すると、修正は出来ません。
      </v-card-text>
      <v-card-text class="text-center">
        ※送信ボタンは1度だけクリック
      </v-card-text>
      <v-divider />

      <v-card-actions class="justify-center">
        <v-btn color="grey darken-1" text @click="dialog=false">
          キャンセル
        </v-btn>
        <v-btn color="primary" text @click.once="send">
          送信
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default ({
  name: 'SendButton',
  props: {
    active: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      dialog: false
    }
  },
  methods: {
    send () {
      this.$emit('send')
      this.dialog = false
    }
  }
})
</script>
